import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'

type JoinUserSuccess = paths['/api/carts/multi-carts/{multiCartId}/users/join']['post']['responses']['201']['content']['application/json']

export async function joinUserToMultiCart(multiCartId: string) {
  await request.post<JoinUserSuccess, {}>(`/api/carts/multi-carts/${multiCartId}/users/join`, {}, { credentials: 'include' })
  return { newlyJoinedCartId: multiCartId }
}
